import './App.css';
import { useEffect, useRef, useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import {
  AirVent, ArrowDown, ArrowLeft, ArrowRight, Bath, BedDouble, CalendarDays, Car, Check, ChevronLeft, ChevronRight, Droplets,
  Clock3, Coffee, Flame, Instagram, Leaf, Mail, MapPin, Menu, MessageCircle, Monitor,
  Mountain, PawPrint, Phone, ReceiptText, Share2, ShowerHead, Sparkles, Star, Trees, Users, Utensils,
  Wifi,
  X
} from 'lucide-react';
import Logo from './images/navut_logo_circle.png';
import P1 from './images/property_compressed/p1.jpg';
import P2 from './images/property_compressed/p2.jpg';
import P3 from './images/property_compressed/p3.jpg';
import P4 from './images/property_compressed/p4.jpg';
import P5 from './images/property_compressed/p5.jpg';
import P6 from './images/property_compressed/p6.jpg';
import P7 from './images/property_compressed/p7.jpg';
import P8 from './images/property_compressed/p8.jpg';
import P9 from './images/property_compressed/p9.jpg';
import P10 from './images/property_compressed/p10.jpg';
import P11 from './images/property_compressed/p11.jpg';
import P12 from './images/property_compressed/p12.jpg';
import P13 from './images/property_compressed/p13.jpg';
import P14 from './images/property_compressed/p14.jpg';
import P15 from './images/property_compressed/p15.jpg';
import P16 from './images/property_compressed/p16.jpg';
import P17 from './images/property_compressed/p17.png';
import P18 from './images/property_compressed/p18.jpg';
import P19 from './images/property_compressed/p19.jpg';
import P20 from './images/property_compressed/p20.jpg';
import P21 from './images/property_compressed/p21.jpg';
import P22 from './images/property_compressed/p22.jpg';
import P23 from './images/property_compressed/p23.jpg';
import P24 from './images/property_compressed/p24.jpg';
import P25 from './images/property_compressed/p25.jpg';
import P26 from './images/property_compressed/p26.jpg';
import DL1 from './images/dl_compressed/dl_1.jpg';
import DL2 from './images/dl_compressed/dl_2.jpg';
import DL3 from './images/dl_compressed/dl_3.jpg';
import DL4 from './images/dl_compressed/dl_4.jpg';
import DL5 from './images/dl_compressed/dl_5.jpg';
import DL6 from './images/dl_compressed/dl_6.jpg';
import DL7 from './images/dl_compressed/dl_7.jpg';
import DL8 from './images/dl_compressed/dl_8.jpeg';
import DL9 from './images/dl_compressed/dl_9.jpeg';
import DL10 from './images/dl_compressed/dl_10.jpeg';
import SDL1 from './images/sdl_compressed/sdl_1.jpg';
import SDL2 from './images/sdl_compressed/sdl_2.jpg';
import SDL3 from './images/sdl_compressed/sdl_3.jpg';
import SDL4 from './images/sdl_compressed/sdl_4.jpg';
import SDL5 from './images/sdl_compressed/sdl_5.jpg';
import SDL6 from './images/sdl_compressed/sdl_6.jpg';
import SDL7 from './images/sdl_compressed/sdl_7.jpg';
import SDL8 from './images/sdl_compressed/sdl_8.jpg';
import SDL9 from './images/sdl_compressed/sdl_9.jpg';
import SDL10 from './images/sdl_compressed/sdl_10.jpeg';
import SDL11 from './images/sdl_compressed/sdl_11.jpeg';
import SDL12 from './images/sdl_compressed/sdl_12.jpeg';
import Agoda from './images/agodalogo.png';
import Makemytrip from './images/makemytriplogo.png';
import Goibibo from './images/goibibologo.png';
import BookingCom from './images/bookingcomlogo.png';
import GoogleLogo from './images/googlelogo.png';
import NavutOneMockup from './images/navutone_mockup.png';

const PHONE = '+919845286195';
const MAPS_URL = 'https://maps.app.goo.gl/F2dxEjB7SJDcS4cCA';
const GOOGLE_REVIEWS_URL = 'https://www.google.com/maps/search/?api=1&query=Navut+Homestay+Kedamallur+Coorg';
const MAPS_EMBED_URL = 'https://www.google.com/maps?q=Navut+Homestay,+Kedamallur,+Virajpet,+Karnataka+571218&output=embed&t=k&z=17';
const bookingPartners = [
  { name: 'Agoda', logo: Agoda, url: 'https://www.agoda.com/navut-homestay/hotel/coorg-in.html' },
  { name: 'MakeMyTrip', logo: Makemytrip, url: 'https://www.makemytrip.com/hotels/navut_homestay-details-coorg.html' },
  { name: 'Goibibo', logo: Goibibo, url: 'https://www.goibibo.com/hotels/navut-homestay-hotel-in-coorg-7733265156926483396/' },
  { name: 'Booking.com', logo: BookingCom, url: 'https://www.booking.com/hotel/in/navut-homestay-a-secluded-forest-escape-amidst-coorgs-lush-coffee-plantations.html' }
];

const amenityGroups = [
  { icon: BedDouble, title: 'Sleep & space', items: ['King bed and sofa bed that comfortably fits 2 adults', 'Spacious family rooms', 'Wardrobe and work desk', 'Linen and fresh bedding'] },
  { icon: AirVent, title: 'Room comfort', items: ['Air conditioning in every room', 'Iron and ironing table', 'Electric kettle', 'Daily housekeeping'] },
  { icon: Bath, title: 'Private bathroom', items: ['Private attached bathroom', '24-hour hot water', 'Complimentary toiletries', 'Fresh towels'] },
  { icon: Monitor, title: 'Media & connection', items: ['Free high-speed Wi-Fi', 'Flat-screen television', 'Satellite channels', 'Telephone'] },
  { icon: Utensils, title: 'Food & dining', items: ['Complimentary breakfast', 'Vegetarian and non-vegetarian meals', 'Chargeable lunch and dinner buffet', 'In-house restaurant'] },
  { icon: Trees, title: 'Estate life', items: ['4-acre coffee estate', 'Garden and terrace', 'Private balcony or porch', 'Outdoor fireplace'] },
  { icon: Car, title: 'Arrival & parking', items: ['Free on-site parking', 'Private parking', 'No advance parking booking', 'Luggage assistance'] },
  { icon: PawPrint, title: 'Families & pets', items: ['Family-friendly rooms', 'Pets are welcome', 'No extra pet fee', 'Open spaces to explore'] },
  { icon: Sparkles, title: 'Guest services', items: ['Caretaker on property', 'Multilingual staff', 'First-aid support', 'Non-smoking rooms available'] }
];

const nearby = [
  {
    category: 'Hills & waterfalls',
    places: [
      ['Nalknad Palace & Tadiandamol trail', '10–16 km'],
      ['Chelavara Falls', '15 km'],
      ['Kabbe Hills', '19 km'],
      ['Raja’s Seat', '36 km'],
      ['Mandalpatti Viewpoint', '40 km'],
      ['Abbey Falls', '44 km'],
      ['Iruppu Falls', '54 km']
    ]
  },
  {
    category: 'Heritage & sacred places',
    places: [
      ['Omkareshwara Temple', '36 km'],
      ['Madikeri Fort', '38 km'],
      ['Bhagamandala', '48 km'],
      ['Talacauvery & Brahmagiri Hills', '50 km'],
      ['Namdroling Golden Temple', '56 km']
    ]
  },
  {
    category: 'Wildlife & adventure',
    places: [
      ['Dubare Elephant Camp', '40 km'],
      ['Barapole River Rafting', '45 km'],
      ['Nagarhole National Park', '48 km'],
      ['Brahmagiri Wildlife Sanctuary', '50 km']
    ]
  }
];

const propertyImages = [
  P16, P3, P21, P8, P18, P1, P24, P10, P17, P5, P22, P12, P19,
  P6, P25, P14, P20, P2, P23, P9, P26, P4, P15, P7, P11, P13
];
const deluxeImages = [DL3, DL5, DL1, DL4, DL2, DL6, DL7, DL8, DL9, DL10];
const superDeluxeImages = [SDL1, SDL5, SDL2, SDL3, SDL6, SDL4, SDL7, SDL8, SDL9, SDL10, SDL11, SDL12];

const roomTypeDetails = {
  deluxe: {
    name: 'Deluxe Room', inventoryName: 'Deluxe', size: '34 m²', image: DL3, images: deluxeImages, detail: 'Mountain/jungle view · balcony or private porch',
    amenities: [[Users, 'Up to 4 guests'], [BedDouble, 'Sofa bed fits 2 adults'], [Coffee, 'Breakfast included'], [ShowerHead, 'Private shower'], [Droplets, '24-hour hot water'], [AirVent, 'Air conditioned'], [Wifi, 'Free Wi-Fi']]
  },
  superDeluxe: {
    name: 'Super Deluxe Room', inventoryName: 'Super Deluxe', size: '42 m²', image: SDL1, images: superDeluxeImages, detail: 'Mountain/jungle view · bathtub · balcony or porch',
    amenities: [[Users, 'Up to 4 guests'], [BedDouble, 'Sofa bed fits 2 adults'], [Bath, 'Shower + bathtub'], [Droplets, '24-hour hot water'], [Coffee, 'Breakfast included'], [AirVent, 'Air conditioned'], [Wifi, 'Free Wi-Fi']]
  }
};

const SUPABASE_URL = 'https://eocjyobboxuzogdiyhof.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVvY2p5b2Jib3h1em9nZGl5aG9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMzNjA2MzQsImV4cCI6MjA2ODkzNjYzNH0.5M0b42GOWuiw5Zoddl5OkEXu4_6-qD3kzVvQJCkBuHw';

function Counter({ label, value, onChange, min = 0, max = 12 }) {
  return (
    <div className="booking-counter">
      <span>{label}</span>
      <div>
        <button type="button" onClick={() => onChange(Math.max(min, value - 1))} aria-label={`Fewer ${label}`}>−</button>
        <strong>{value}</strong>
        <button type="button" onClick={() => onChange(Math.min(max, value + 1))} aria-label={`More ${label}`}>+</button>
      </div>
    </div>
  );
}

function BookingModal({ onClose, onShare }) {
  const modalRef = useRef(null);
  const requestIdRef = useRef(window.crypto?.randomUUID?.() || `NAVUT-${Date.now()}`);
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({ name: '', phone: '', checkin: '', checkout: '', roomCounts: { deluxe: 0, superDeluxe: 0 }, adults: 2, children: 0, childAges: [] });
  const [roomConfig, setRoomConfig] = useState({ status: 'loading', deluxe: null, superDeluxe: null, error: '' });
  const [availability, setAvailability] = useState({ status: 'idle', deluxe: 0, superDeluxe: 0, error: '' });
  const [amenitiesExpanded, setAmenitiesExpanded] = useState(false);
  const [roomDetailsExpanded, setRoomDetailsExpanded] = useState(true);
  const [submission, setSubmission] = useState({ status: 'idle', reference: '', error: '' });
  const [discountCode, setDiscountCode] = useState('');
  const [appliedDiscountCode, setAppliedDiscountCode] = useState('');
  const [discountError, setDiscountError] = useState('');
  const roomTypes = {
    deluxe: { ...roomTypeDetails.deluxe, price: roomConfig.deluxe?.price ?? null },
    superDeluxe: { ...roomTypeDetails.superDeluxe, price: roomConfig.superDeluxe?.price ?? null }
  };
  const selectedTypes = Object.keys(roomTypes).filter(type => form.roomCounts[type] > 0);
  const hasRoomSelection = selectedTypes.length > 0;
  const selectedRoom = roomTypes[selectedTypes[0] || 'deluxe'];
  const update = (key, value) => setForm(current => ({ ...current, [key]: value }));
  const today = new Date().toISOString().split('T')[0];
  const steps = ['Stay details', 'Choose rooms', 'Comforts', 'Review'];
  const guestCount = form.adults + form.children;
  const minimumRooms = Math.max(1, Math.ceil(guestCount / 4));
  const totalRooms = form.roomCounts.deluxe + form.roomCounts.superDeluxe;
  const nights = form.checkin && form.checkout && form.checkout > form.checkin ? Math.round((new Date(`${form.checkout}T00:00:00Z`) - new Date(`${form.checkin}T00:00:00Z`)) / 86400000) : 0;
  const roomRatePerNight = form.roomCounts.deluxe * roomTypes.deluxe.price + form.roomCounts.superDeluxe * roomTypes.superDeluxe.price;
  const extraAdults = Math.max(0, form.adults - totalRooms * 2);
  const extraAdultRatePerNight = extraAdults * 999;
  const roomCharges = roomRatePerNight * nights;
  const extraAdultCharges = extraAdultRatePerNight * nights;
  const subtotal = roomCharges + extraAdultCharges;
  const selectedDiscounts = selectedTypes
    .map(type => roomConfig[type])
    .filter(config => config?.discountCode && Number.isFinite(config.discountPercent) && config.discountPercent > 0);
  const lowestSelectedDiscountPercent = selectedDiscounts.length > 0
    ? Math.min(...selectedDiscounts.map(config => config.discountPercent))
    : 0;
  const eligibleDiscounts = selectedDiscounts.filter(config => config.discountPercent === lowestSelectedDiscountPercent);
  const appliedDiscount = eligibleDiscounts
    .find(config => config.discountCode.toLowerCase() === appliedDiscountCode.toLowerCase());
  const discountPercent = appliedDiscount ? lowestSelectedDiscountPercent : 0;
  const discountAmount = subtotal * discountPercent / 100;
  const discountedSubtotal = subtotal - discountAmount;
  const gstAmount = discountedSubtotal * 0.05;
  const estimatedTotal = discountedSubtotal + gstAmount;
  const childAgesValid = form.childAges.length === form.children && form.childAges.every(age => age !== '' && Number(age) >= 0 && Number(age) < 18);
  const guestAllocation = (() => {
    const rooms = Object.keys(roomTypes).flatMap(type => Array.from({ length: form.roomCounts[type] }, (_, index) => ({ type, label: `${roomTypes[type].name.replace(' Room', '')} ${index + 1}`, adults: 0, children: 0 })));
    let adultsLeft = form.adults;
    let childrenLeft = form.children;
    // Give every selected room one guest first whenever the guest count allows it.
    rooms.forEach(room => {
      if (adultsLeft > 0) {
        room.adults = 1;
        adultsLeft -= 1;
      } else if (childrenLeft > 0) {
        room.children = 1;
        childrenLeft -= 1;
      }
    });
    // Then distribute the second included adult across rooms before filling extras.
    rooms.forEach(room => {
      const includedAdults = Math.min(2 - room.adults, 4 - room.adults - room.children, adultsLeft);
      room.adults += includedAdults;
      adultsLeft -= includedAdults;
    });
    rooms.forEach(room => {
      const extraRoomAdults = Math.min(4 - room.adults, adultsLeft);
      room.adults += extraRoomAdults;
      adultsLeft -= extraRoomAdults;
    });
    rooms.forEach(room => {
      const roomChildren = Math.min(4 - room.adults, childrenLeft);
      room.children += roomChildren;
      childrenLeft -= roomChildren;
    });
    return { rooms, unallocated: adultsLeft + childrenLeft };
  })();
  const canBookSelection = availability.status === 'success' && totalRooms >= minimumRooms && Object.keys(roomTypes).every(type => form.roomCounts[type] <= availability[type]);
  const updateRoomCount = (type, value) => setForm(current => ({ ...current, roomCounts: { ...current.roomCounts, [type]: value } }));
  const updateChildren = value => setForm(current => ({ ...current, children: value, childAges: Array.from({ length: value }, (_, index) => current.childAges[index] ?? '') }));
  const updateChildAge = (index, value) => setForm(current => ({ ...current, childAges: current.childAges.map((age, ageIndex) => ageIndex === index ? value : age) }));
  const formatPrice = value => `₹${value.toLocaleString('en-IN', { minimumFractionDigits: Number.isInteger(value) ? 0 : 2, maximumFractionDigits: 2 })}`;
  const formatStayDate = value => value ? new Date(`${value}T00:00:00Z`).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }) : '—';
  const applyDiscountCode = () => {
    const code = discountCode.trim().toUpperCase();
    if (!code) return;
    const matchingDiscounts = selectedDiscounts
      .filter(config => config.discountCode.toLowerCase() === code.toLowerCase());
    if (matchingDiscounts.length === 0) {
      setAppliedDiscountCode('');
      setDiscountError('This code is not valid for the selected room type.');
      return;
    }
    const matchingEligibleDiscount = matchingDiscounts
      .find(config => config.discountPercent === lowestSelectedDiscountPercent);
    if (!matchingEligibleDiscount) {
      const eligibleCodes = [...new Set(eligibleDiscounts.map(config => config.discountCode))].join(' or ');
      setAppliedDiscountCode('');
      setDiscountError(`Mixed room selections are eligible for the lowest discount of ${lowestSelectedDiscountPercent}%. Use code ${eligibleCodes}.`);
      return;
    }
    setDiscountCode(code);
    setAppliedDiscountCode(code);
    setDiscountError('');
  };

  const submitBookingRequest = async () => {
    if (submission.status === 'loading') return;
    setSubmission({ status: 'loading', reference: '', error: '' });
    try {
      const response = await fetch(`${SUPABASE_URL}/functions/v1/send-booking-request`, {
        method: 'POST',
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          requestId: requestIdRef.current,
          guest: { name: form.name.trim(), phone: form.phone.trim(), adults: form.adults, children: form.children, childAges: form.childAges.map(Number) },
          stay: { checkin: form.checkin, checkout: form.checkout, nights },
          rooms: { deluxe: form.roomCounts.deluxe, superDeluxe: form.roomCounts.superDeluxe },
          discountCode: appliedDiscountCode || null,
          pricing: {
            roomRates: { deluxe: roomTypes.deluxe.price, superDeluxe: roomTypes.superDeluxe.price },
            roomCharges,
            extraAdults,
            extraAdultRatePerPersonPerNight: 999,
            extraAdultRatePerNight,
            extraAdultCharges,
            subtotal,
            discountPercent,
            discountAmount,
            discountedSubtotal,
            gst: gstAmount,
            total: estimatedTotal
          }
        })
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || 'Request could not be sent');
      setSubmission({ status: 'success', reference: result.reference || requestIdRef.current, error: '' });
      modalRef.current?.scrollTo?.({ top: 0, behavior: 'smooth' });
    } catch (error) {
      setSubmission({ status: 'error', reference: '', error: 'We could not send your request. Please try again.' });
    }
  };

  useEffect(() => {
    const controller = new AbortController();

    const loadRoomConfig = async () => {
      try {
        const query = new URLSearchParams({ select: 'name,physical_room_count,room_rate_direct,discount_value_percent,discount_code', is_active: 'eq.true' });
        const response = await fetch(`${SUPABASE_URL}/rest/v1/property_room_types?${query}`, {
          headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(`Room configuration request failed (${response.status})`);

        const rows = await response.json();
        const config = {};
        rows.forEach(row => {
          const normalizedType = String(row.name || '').toLowerCase().replace(/[^a-z]/g, '').replace(/room$/, '');
          const type = normalizedType === 'deluxe' ? 'deluxe' : normalizedType === 'superdeluxe' ? 'superDeluxe' : null;
          if (!type) return;

          const physicalRoomCount = Number(row.physical_room_count);
          const price = Number(row.room_rate_direct);
          const rawDiscountPercent = Number(row.discount_value_percent);
          const discountPercent = Number.isFinite(rawDiscountPercent) && rawDiscountPercent > 0 ? Math.min(rawDiscountPercent, 100) : 0;
          const discountCode = discountPercent > 0 ? String(row.discount_code || '').trim() : '';
          if (Number.isFinite(physicalRoomCount) && physicalRoomCount >= 0 && Number.isFinite(price) && price >= 0) {
            config[type] = { physicalRoomCount, price, discountPercent, discountCode };
          }
        });

        if (!config.deluxe || !config.superDeluxe) throw new Error('Room configuration is incomplete');
        setRoomConfig({ status: 'success', deluxe: config.deluxe, superDeluxe: config.superDeluxe, error: '' });
      } catch (error) {
        if (error.name !== 'AbortError') {
          setRoomConfig({ status: 'error', deluxe: null, superDeluxe: null, error: 'We could not load room inventory and rates. Please try again.' });
        }
      }
    };

    loadRoomConfig();
    return () => controller.abort();
  }, []);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const closeOnEscape = event => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', closeOnEscape);
    };
  }, [onClose]);

  useEffect(() => {
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    modalRef.current?.scrollTo?.({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (step < 2) {
      setRoomDetailsExpanded(true);
      return undefined;
    }
    const collapseTimer = window.setTimeout(() => setRoomDetailsExpanded(false), reduceMotion ? 0 : 400);
    return () => window.clearTimeout(collapseTimer);
  }, [step]);

  useEffect(() => {
    if (roomConfig.status === 'loading') {
      setAvailability({ status: 'loading', deluxe: 0, superDeluxe: 0, error: '' });
      return undefined;
    }
    if (roomConfig.status === 'error') {
      setAvailability({ status: 'error', deluxe: 0, superDeluxe: 0, error: roomConfig.error });
      return undefined;
    }
    if (!form.checkin || !form.checkout || form.checkout <= form.checkin) {
      setAvailability({ status: 'idle', deluxe: roomConfig.deluxe.physicalRoomCount, superDeluxe: roomConfig.superDeluxe.physicalRoomCount, error: '' });
      return undefined;
    }

    const controller = new AbortController();
    const loadAvailability = async () => {
      setAvailability(current => ({ ...current, status: 'loading', error: '' }));
      try {
        const query = new URLSearchParams({ select: 'room_type,date,reserve_count', order: 'date.asc' });
        query.append('date', `gte.${form.checkin}`);
        query.append('date', `lt.${form.checkout}`);
        const response = await fetch(`${SUPABASE_URL}/rest/v1/room_inventory?${query}`, {
          headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(`Availability request failed (${response.status})`);
        const rows = await response.json();
        const reservedByDate = {};
        rows.forEach(row => {
          const normalizedType = String(row.room_type || '').toLowerCase().replace(/[^a-z]/g, '').replace(/room$/, '');
          const type = normalizedType === 'deluxe' ? 'deluxe' : normalizedType === 'superdeluxe' ? 'superDeluxe' : null;
          if (!type) return;
          const date = String(row.date).slice(0, 10);
          reservedByDate[date] ||= { deluxe: 0, superDeluxe: 0 };
          reservedByDate[date][type] += Number(row.reserve_count) || 0;
        });
        const nightly = Object.values(reservedByDate);
        const result = {
          status: 'success',
          deluxe: Math.max(0, roomConfig.deluxe.physicalRoomCount - Math.max(0, ...nightly.map(day => day.deluxe))),
          superDeluxe: Math.max(0, roomConfig.superDeluxe.physicalRoomCount - Math.max(0, ...nightly.map(day => day.superDeluxe))),
          error: ''
        };
        setAvailability(result);
        setForm(current => {
          const roomCounts = {
            deluxe: Math.min(current.roomCounts.deluxe, result.deluxe),
            superDeluxe: Math.min(current.roomCounts.superDeluxe, result.superDeluxe)
          };
          return { ...current, roomCounts };
        });
      } catch (error) {
        if (error.name !== 'AbortError') setAvailability({ status: 'error', deluxe: 0, superDeluxe: 0, error: 'We could not verify live availability. Please try again.' });
      }
    };
    loadAvailability();
    return () => controller.abort();
  }, [form.checkin, form.checkout, minimumRooms, roomConfig.status, roomConfig.deluxe, roomConfig.superDeluxe, roomConfig.error]);

  const canContinue = step !== 0 || (form.name.trim() && form.phone.trim() && form.checkin && form.checkout && form.checkout > form.checkin && childAgesValid);

  return (
    <div className="booking-modal-backdrop" role="presentation" onMouseDown={event => event.target === event.currentTarget && onClose()}>
      <div ref={modalRef} className="booking-modal" role="dialog" aria-modal="true" aria-labelledby="booking-modal-title">
        <header className="booking-modal-header">
          <div><span>DIRECT BOOKING REQUEST</span><h2 id="booking-modal-title">Plan your stay.</h2></div>
          <div className="booking-modal-header-actions"><button type="button" onClick={onShare}><Share2 /> <span>Share</span></button><button type="button" onClick={onClose} aria-label="Close booking form"><X /></button></div>
        </header>

        <div className="booking-progress" aria-label={`Step ${step + 1} of ${steps.length}`}>
          {steps.map((label, index) => <div key={label} className={index <= step ? 'active' : ''}><span>{index + 1}</span><small>{label}</small></div>)}
        </div>

        <div className={`booking-modal-body ${step === 0 ? 'stay-details-only' : ''}`}>
          <div className="booking-form-pane">
            {step === 0 && <div className="booking-step">
              <p className="booking-kicker">01 · YOUR STAY</p><h3>When are you joining us?</h3>
              <div className="booking-fields-row">
                <label className="booking-field"><span>Booker Name</span><input autoFocus value={form.name} onChange={e => update('name', e.target.value)} placeholder="Enter your full name" /></label>
                <label className="booking-field"><span>Phone number</span><input type="tel" value={form.phone} onChange={e => update('phone', e.target.value)} placeholder="Enter your contact number" /><small>Booking confirmation will be sent via WhatsApp/SMS.</small></label>
              </div>
              <div className="booking-fields-row">
                <label className="booking-field"><span>Check-in</span><input type="date" min={today} value={form.checkin} onChange={e => update('checkin', e.target.value)} /></label>
                <label className="booking-field"><span>Check-out</span><input type="date" min={form.checkin || today} value={form.checkout} onChange={e => update('checkout', e.target.value)} /></label>
              </div>
              {form.checkin && form.checkout && form.checkout <= form.checkin && <p className="booking-error">Check-out must be after check-in.</p>}
              <div className="booking-counters">
                <Counter label="Adults" value={form.adults} onChange={value => update('adults', value)} min={1} max={24} />
                <Counter label="Children" value={form.children} onChange={updateChildren} max={23} />
              </div>
              {form.children > 0 && <div className="child-ages"><div><strong>Children’s ages</strong><small>Children below 18 stay free</small></div><div>{form.childAges.map((age, index) => <label key={index}><span>Child {index + 1}</span><input type="number" min="0" max="17" inputMode="numeric" value={age} onChange={event => updateChildAge(index, event.target.value)} placeholder="Age" /></label>)}</div></div>}
              {form.childAges.some(age => age !== '' && Number(age) >= 18) && <p className="booking-error">Guests aged 18 or above must be counted as adults.</p>}
              {form.childAges.some(age => age !== '' && Number(age) < 0) && <p className="booking-error">Please enter a valid age for each child.</p>}
              <div className="booking-note"><CalendarDays /><p><strong>Arrival made simple</strong><span>Check-in is from 1:00 PM. Check-out is by 11:00 AM.</span></p></div>
            </div>}

            {step === 1 && <div className="booking-step">
              <p className="booking-kicker">02 · YOUR ROOM</p><h3>Choose the space that suits you.</h3>
              {availability.status === 'loading' && <div className="availability-message loading">Checking every night of your stay…</div>}
              {availability.status === 'error' && <div className="availability-message unavailable">{availability.error}</div>}
              <div className="booking-room-options">
                {Object.entries(roomTypes).map(([key, room]) => <div key={key} className={`booking-room-choice ${form.roomCounts[key] > 0 ? 'selected' : ''} ${availability.status === 'success' && availability[key] === 0 ? 'unavailable' : ''}`}>
                  <div className="booking-room-carousel"><PhotoCarousel images={room.images} label={room.name.replace(' Room', '').toUpperCase()} /></div><span><strong>{room.name}</strong>{roomConfig[key]?.discountPercent > 0 && roomConfig[key]?.discountCode && <span className="direct-booking-offer">Save {roomConfig[key].discountPercent}% · Use code {roomConfig[key].discountCode}</span>}<small>{room.size} · Mountain/jungle view</small><b>{room.price === null ? 'Loading rate…' : formatPrice(room.price)} <small>/ room / night · 2 adults</small></b><em>{availability.status === 'success' ? (availability[key] > 0 ? `${availability[key]} ${availability[key] === 1 ? 'room' : 'rooms'} available` : 'No rooms available') : 'Checking availability…'}</em></span>
                  <ul className="booking-room-amenities">{room.amenities.map(([Icon, label]) => <li key={label}><Icon />{label}</li>)}</ul>
                  <div className="room-type-counter"><Counter label="Select rooms" value={form.roomCounts[key]} onChange={value => updateRoomCount(key, value)} min={0} max={availability.status === 'success' ? availability[key] : 0} /></div>
                </div>)}
              </div>
              {availability.status === 'success' && availability.deluxe + availability.superDeluxe < minimumRooms && <div className="availability-message unavailable booking-blocked" role="alert"><strong>This stay cannot be booked.</strong><span>We do not have enough rooms available for every night of this stay. Change your dates or guest count to continue.</span></div>}
              {availability.status === 'success' && totalRooms === 0 && <div className="room-selection-prompt">Please select rooms for {form.adults} {form.adults === 1 ? 'adult' : 'adults'} and {form.children} {form.children === 1 ? 'child' : 'children'}.</div>}
              {totalRooms > 0 && totalRooms < minimumRooms && <p className="booking-error">These rooms accommodate {totalRooms * 4} guests. Please add another room so every guest is accommodated.</p>}
              <p className="booking-helper">Mix room types as you like. Each room has one king bed and a sofa bed that comfortably fits 2 adults, accommodating up to four guests in total.</p>
            </div>}

            {step === 2 && <div className="booking-step">
              <p className="booking-kicker">03 · YOUR COMFORTS</p><h3>Everything waiting for you.</h3>
              <div className={`modal-amenities ${amenitiesExpanded ? 'expanded' : ''}`}><h4>Everything included or available</h4>{amenityGroups.map(({ icon: Icon, title, items }) => <article key={title}><div><Icon /><strong>{title}</strong></div>{items.map(item => <span key={item}><Check />{item}</span>)}</article>)}<button className="amenities-toggle" type="button" onClick={() => setAmenitiesExpanded(value => !value)}>{amenitiesExpanded ? 'Show less' : 'See more'} <ChevronRight /></button></div>
            </div>}

            {step === 3 && submission.status !== 'success' && <div className="booking-step">
              <p className="booking-kicker">04 · REVIEW</p><h3>Your stay, at a glance.</h3>
              <div className="booking-summary">
                <div><span>Guest</span><strong>{form.name || 'Not provided'}</strong></div>
                <div><span>Phone</span><strong>{form.phone || 'Not provided'}</strong></div>
                <div><span>Dates</span><strong>{formatStayDate(form.checkin)} <ArrowRight /> {formatStayDate(form.checkout)}</strong></div>
                <div><span>Rooms</span><strong>{form.roomCounts.deluxe > 0 && `${form.roomCounts.deluxe} × Deluxe`}{form.roomCounts.deluxe > 0 && form.roomCounts.superDeluxe > 0 && ' · '}{form.roomCounts.superDeluxe > 0 && `${form.roomCounts.superDeluxe} × Super Deluxe`}</strong></div>
                <div><span>Guests</span><strong>{form.adults} adults · {form.children} children</strong></div>
              </div>
              <div className="confirmation-note"><Check /><p><strong>Ready to send</strong><span>This is a direct booking request. Navut will confirm availability, allocation and final terms separately.</span></p></div>
              {submission.status === 'error' && <div className="submission-error" role="alert">{submission.error}</div>}
            </div>}

            {step === 3 && submission.status === 'success' && <div className="booking-step booking-success" role="status"><span><Check /></span><p className="booking-kicker">REQUEST SENT</p><h3>Thank you, {form.name.split(' ')[0]}.</h3><p>Your direct booking request has been sent. Someone from Navut will get back to you shortly to confirm your stay.</p><small>Reference · {submission.reference}</small><button type="button" onClick={onClose}>Close</button></div>}

            {submission.status !== 'success' && <div className="booking-modal-actions">
              {step > 0 && <button type="button" className="booking-back" onClick={() => setStep(step - 1)}><ArrowLeft /> Back</button>}
              {step < 3 ? <button type="button" className="booking-next" disabled={!canContinue || (step === 1 && !canBookSelection)} onClick={() => setStep(step + 1)}>Continue <ArrowRight /></button> : <button type="button" className="booking-submit" disabled={submission.status === 'loading'} onClick={submitBookingRequest}>{submission.status === 'loading' ? 'Sending request…' : 'Submit direct booking request'} {submission.status !== 'loading' && <ArrowRight />}</button>}
            </div>}
          </div>

          {step > 0 && <aside className="booking-visual-pane">
            <div className={`visual-room-photo ${!hasRoomSelection ? 'empty' : ''} ${selectedTypes.length > 1 ? 'mixed' : ''}`}>{hasRoomSelection ? (selectedTypes.length > 1 ? <div className="visual-room-collage">{selectedTypes.map(type => <figure key={type}><img src={roomTypes[type].image} alt={`${roomTypes[type].name} preview`} /><figcaption>{roomTypes[type].name.replace(' Room', '')}</figcaption></figure>)}</div> : <img src={selectedRoom.image} alt={`${selectedRoom.name} preview`} />) : <BedDouble aria-hidden="true" />}<span>{hasRoomSelection ? 'YOUR SELECTION' : 'AWAITING SELECTION'}</span></div>
            <h3>{hasRoomSelection ? (selectedTypes.length > 1 ? 'Mixed room selection' : selectedRoom.name) : 'Choose your rooms'}</h3><p>{hasRoomSelection ? (selectedTypes.length > 1 ? `${form.roomCounts.deluxe} Deluxe · ${form.roomCounts.superDeluxe} Super Deluxe` : selectedRoom.detail) : `Select enough rooms for all ${guestCount} guests.`}</p>
            {hasRoomSelection && <div className="price-breakdown"><span>Room charges</span><b>{formatPrice(roomCharges)}</b>{extraAdults > 0 && <><span>Extra adults</span><b>{formatPrice(extraAdultCharges)}</b></>}<span>Subtotal</span><b>{formatPrice(subtotal)}</b>{discountPercent > 0 && <><span>Discount · {discountPercent}%</span><b>−{formatPrice(discountAmount)}</b><span>Discounted subtotal</span><b>{formatPrice(discountedSubtotal)}</b></>}<span>GST · 5%</span><b>{formatPrice(gstAmount)}</b></div>}
            {hasRoomSelection && <div className="discount-code"><label htmlFor="discount-code">Apply discount</label><div><input id="discount-code" value={discountCode} onChange={event => { setDiscountCode(event.target.value); setAppliedDiscountCode(''); setDiscountError(''); }} placeholder="Enter code" /><button type="button" onClick={applyDiscountCode} disabled={!discountCode.trim()}>Apply</button></div>{appliedDiscountCode && appliedDiscount && <small><Check /> {discountPercent}% discount applied with {appliedDiscountCode}.</small>}{discountError && <small className="error">{discountError}</small>}</div>}
            {hasRoomSelection && <div className="live-price"><span>ESTIMATED STAY TOTAL</span><strong>{formatPrice(estimatedTotal)}</strong><small>{nights} {nights === 1 ? 'night' : 'nights'} · {totalRooms} {totalRooms === 1 ? 'room' : 'rooms'}{extraAdults > 0 ? ` · ${extraAdults} extra ${extraAdults === 1 ? 'adult' : 'adults'}` : ''}</small></div>}
            {step >= 2 && hasRoomSelection && <button className={`room-details-toggle ${roomDetailsExpanded ? 'open' : ''}`} type="button" onClick={() => setRoomDetailsExpanded(value => !value)} aria-expanded={roomDetailsExpanded}>Allocation <ChevronRight /></button>}
            {(step < 2 || roomDetailsExpanded) && <div className="room-allocation-details">
            {hasRoomSelection && <div className="guest-allocation"><div className="guest-allocation-title"><span>GUEST ALLOCATION</span><small>{guestCount - guestAllocation.unallocated} of {guestCount} placed</small></div><div className="guest-allocation-grid">{guestAllocation.rooms.map((room, index) => {
              const occupancy = room.adults + room.children;
              return <div className="guest-room" key={`${room.type}-${index}`}><BedDouble /><strong>{room.label}</strong><small>{room.adults}A{room.children > 0 ? ` · ${room.children}C` : ''}</small><b>{occupancy}/4</b></div>;
            })}</div>{guestAllocation.unallocated > 0 && <p><Users /> {guestAllocation.unallocated} {guestAllocation.unallocated === 1 ? 'guest still needs' : 'guests still need'} a room.</p>}</div>}
            <div className="room-location-note"><BedDouble /><p><strong>Room location</strong><span>Rooms may be on the first floor or ground floor.</span></p></div>
            </div>}
          </aside>}
        </div>
      </div>
    </div>
  );
}

function PhotoCarousel({ images, label }) {
  const [active, setActive] = useState(0);
  const move = (direction) => setActive((active + direction + images.length) % images.length);

  return (
    <div className="photo-carousel">
      {images.map((image, index) => (
        <img
          key={image}
          className={index === active ? 'active' : ''}
          src={image}
          alt={`${label} – view ${index + 1}`}
          loading={index === 0 ? 'eager' : 'lazy'}
        />
      ))}
      <span className="room-label">{label}</span>
      <span className="photo-count">{String(active + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}</span>
      <div className="carousel-controls">
        <button onClick={() => move(-1)} aria-label={`Previous ${label} photo`}><ChevronLeft /></button>
        <button onClick={() => move(1)} aria-label={`Next ${label} photo`}><ChevronRight /></button>
      </div>
    </div>
  );
}

function TripadvisorWidget() {
  return (
    <div className="tripadvisor-widget">
      <div id="TA_selfserveprop78" className="TA_selfserveprop">
        <ul id="UMEzBLZcr" className="TA_links lU4DBX9WdCaH">
          <li id="aDz2KoC9J" className="69gSef1wEeQ0">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.tripadvisor.in/Hotel_Review-g1638802-d32769028-Reviews-Navut_Homestay-Virajpet_Kodagu_Coorg_Karnataka.html"
            >
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(() => new URLSearchParams(window.location.search).get('booking') === 'direct');

  const getDirectBookingUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('booking', 'direct');
    url.hash = '';
    return url;
  };

  const openDirectBooking = () => {
    const url = getDirectBookingUrl();
    window.history.replaceState({}, '', `${url.pathname}${url.search}`);
    setBookingOpen(true);
  };

  const closeDirectBooking = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('booking');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    setBookingOpen(false);
  };

  const shareDirectBooking = async () => {
    const url = getDirectBookingUrl().toString();
    try {
      if (navigator.share) await navigator.share({ title: 'Book directly with Navut Homestay', text: 'Check availability and plan your stay directly with Navut.', url });
      else {
        await navigator.clipboard.writeText(url);
        toast.success('Direct booking link copied');
      }
    } catch (error) {
      if (error.name !== 'AbortError') toast.error('Could not share the booking link');
    }
  };

  const share = async () => {
    try {
      if (navigator.share) await navigator.share({ title: 'Navut Homestay', url: window.location.href });
      else {
        await navigator.clipboard.writeText(window.location.href);
        toast.success('Link copied to clipboard');
      }
    } catch (error) {
      if (error.name !== 'AbortError') toast.error('Could not share this page');
    }
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const openPolicy = (id) => {
    const policy = document.getElementById(id);
    if (policy) {
      policy.open = true;
      policy.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="site-shell">
      <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0 } }} />

      <header className="topbar">
        <button className="brand" onClick={() => scrollTo('home')} aria-label="Navut home">
          <img src={Logo} alt="" />
          <span><strong>NAVUT</strong><small>HOMESTAY · COORG</small></span>
        </button>
        <nav className={menuOpen ? 'nav open' : 'nav'} aria-label="Main navigation">
          <button onClick={() => scrollTo('story')}>The stay</button>
          <button onClick={() => scrollTo('rooms')}>Rooms</button>
          <button onClick={() => scrollTo('experience')}>Experience</button>
          <button onClick={() => scrollTo('contact')}>Contact</button>
        </nav>
        <button className="header-cta" onClick={() => scrollTo('book')}>Book your stay <ArrowRight size={16} /></button>
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          {menuOpen ? <X /> : <Menu />}
        </button>
      </header>

      <main>
        <section className="hero" id="home">
          <img src={P16} alt="Navut Homestay surrounded by forest in Coorg" />
          <div className="hero-shade" />
          <div className="hero-content">
            <p className="eyebrow light">A FOREST HOMESTAY IN COORG</p>
            <h1>Come away to<br /><em>the quiet.</em></h1>
            <p className="hero-copy">A secluded retreat set within four acres of coffee plantation, where warm hospitality meets the wild beauty of the Western Ghats.</p>
            <div className="hero-actions">
              <button className="button button-light" onClick={() => scrollTo('book')}>Explore booking options <ArrowRight size={17} /></button>
              <button className="text-button light" onClick={() => scrollTo('story')}>Discover Navut <ArrowDown size={16} /></button>
            </div>
          </div>
          <div className="hero-facts">
            <span><MapPin size={16} /> Kedamallur, Coorg</span>
            <span><Leaf size={16} /> 4-acre coffee estate</span>
            <span><PawPrint size={16} /> Pet friendly</span>
          </div>
        </section>

        <section className="intro section" id="story">
          <div className="section-label"><span>01</span> The stay</div>
          <div className="intro-grid">
            <div>
              <p className="eyebrow">ROOTED IN NATURE</p>
              <h2>Space to breathe.<br />Time to <em>simply be.</em></h2>
            </div>
            <div className="intro-copy">
              <p>Beyond Coorg’s familiar trails lies a quieter kind of escape. Navut is a homestay wrapped in forest and coffee, created for unhurried mornings, generous meals and nights gathered around the fire.</p>
              <p>Wake to mountain air, walk beneath the canopy, and return to the comforts of a spacious room. Every stay includes a wholesome breakfast and our local knowledge, shared freely.</p>
              <button className="inline-link" onClick={() => scrollTo('experience')}>Explore the experience <ArrowRight size={17} /></button>
            </div>
          </div>
          <div className="editorial-gallery">
            <img className="gallery-tall" src={P3} alt="Coffee estate at Navut" />
            <div className="gallery-stack">
              <img src={P6} alt="A peaceful corner of the property" />
              <p><span>“</span>Not a hotel in nature.<br />A home that belongs to it.</p>
            </div>
            <img className="gallery-short" src={P10} alt="Bonfire evening at Navut" />
          </div>
          <div className="property-snapshot">
            <div><strong>4</strong><span>Acres of coffee estate<small>Forest and plantation setting</small></span></div>
            <div><strong>800+</strong><span>Guests welcomed<small>Hosted since 2025</small></span></div>
            <div><strong>4</strong><span>Guests per room<small>King bed + sofa bed for 2 adults</small></span></div>
            <div><strong>34/42</strong><span>m² room sizes<small>Generously proportioned</small></span></div>
          </div>
        </section>

        <section className="rooms section dark-section" id="rooms">
          <div className="section-label light-label"><span>02</span> Accommodation</div>
          <div className="rooms-heading">
            <div><p className="eyebrow light">YOUR PRIVATE RETREAT</p><h2>Rest, beautifully.</h2></div>
            <p>Two generous room styles, each opening onto the green. Breakfast is included with every stay.</p>
          </div>
          <div className="room-grid">
            <article className="room-card">
              <div className="room-image"><PhotoCarousel images={deluxeImages} label="DELUXE" /></div>
              <div className="room-details">
                <div><h3>Deluxe Room</h3><p>34 m² · Mountain/jungle view · Balcony or private porch</p></div>
                <ul><li><Users size={16} /> Up to 4 guests</li><li><BedDouble size={16} /> King bed + sofa bed for 2 adults</li><li><Coffee size={16} /> Breakfast included</li><li><ShowerHead size={16} /> Private shower</li><li><Droplets size={16} /> 24-hour hot water</li><li><AirVent size={16} /> Air conditioned</li><li><Wifi size={16} /> Free Wi-Fi</li></ul>
                <button onClick={() => scrollTo('book')}>View booking options <ChevronRight size={17} /></button>
              </div>
            </article>
            <article className="room-card">
              <div className="room-image"><PhotoCarousel images={superDeluxeImages} label="SUPER DELUXE" /></div>
              <div className="room-details">
                <div><h3>Super Deluxe Room</h3><p>42 m² · Mountain/jungle view · Bathtub · Balcony or private porch</p></div>
                <ul><li><Users size={16} /> Up to 4 guests</li><li><BedDouble size={16} /> King bed + sofa bed for 2 adults</li><li><Bath size={16} /> Shower + bathtub</li><li><Droplets size={16} /> 24-hour hot water</li><li><Coffee size={16} /> Breakfast included</li><li><AirVent size={16} /> Air conditioned</li><li><Wifi size={16} /> Free Wi-Fi</li></ul>
                <button onClick={() => scrollTo('book')}>View booking options <ChevronRight size={17} /></button>
              </div>
            </article>
          </div>
          <div className="room-guidance">
            <article><span>01</span><h3>Six rooms, two levels</h3><p>Each floor has two Deluxe rooms and one Super Deluxe room. First-floor rooms have balconies; ground-floor rooms open onto private porches.</p></article>
            <article><span>02</span><h3>One generous bed setup</h3><p>Every room has one king bed and a sofa bed that comfortably fits 2 adults. Together they accommodate up to four guests; no additional bedding is provided.</p></article>
            <article><span>03</span><h3>Fair room allocation</h3><p>Rooms are assigned on a first-come, first-served basis. Your floor and outlook depend on availability when you check in.</p></article>
            <article><span>04</span><h3>Simple occupancy pricing</h3><p>Standard rates cover two adults per night. Additional guests are ₹999 each, up to the four-guest room maximum.</p></article>
          </div>
        </section>

        <section className="experience section" id="experience">
          <div className="section-label"><span>03</span> The experience</div>
          <div className="experience-grid">
            <div className="experience-image"><img src={P24} alt="Lush scenery around Navut Homestay" /><div className="image-note"><Mountain /><span>IN THE HEART OF<br />COORG’S HIGHLANDS</span></div></div>
            <div className="experience-copy">
              <p className="eyebrow">DAYS AT NAVUT</p>
              <h2>Let the forest<br /><em>set the pace.</em></h2>
              <p>There is no itinerary here—only possibilities. Follow a plantation trail after breakfast, seek out a waterfall, or spend the afternoon listening to rain from your balcony.</p>
              <div className="rituals">
                <div><Flame /><span><strong>Bonfire evenings</strong><small>Gather under the stars · complimentary for guests</small></span></div>
                <div><Coffee /><span><strong>Estate mornings</strong><small>Walk through coffee and forest</small></span></div>
                <div><Utensils /><span><strong>Home-style meals</strong><small>Vegetarian & non-vegetarian</small></span></div>
              </div>
            </div>
          </div>
          <div className="nearby">
            <div className="nearby-heading">
              <p className="eyebrow">WORTH THE JOURNEY</p>
              <h3>Beyond the estate.</h3>
              <p>A considered guide to Coorg’s landscapes, heritage and wildlife. Distances are approximate from Navut.</p>
            </div>
            <div className="nearby-groups">
              {nearby.map(group => (
                <div className="nearby-group" key={group.category}>
                  <h4>{group.category}</h4>
                  <div className="nearby-list">
                    {group.places.map(([place, distance]) => <div key={place}><span>{place}</span><small>{distance}</small></div>)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="guestspace section" id="guestspace">
          <div className="section-label light-label"><span>04</span> NavutOne GuestSpace</div>
          <div className="guestspace-grid">
            <div className="guestspace-copy">
              <p className="eyebrow light">YOUR STAY, AT YOUR FINGERTIPS</p>
              <h2>One simple space<br /><em>for everything.</em></h2>
              <p className="guestspace-intro">GuestSpace is your digital companion throughout your stay. From the moment you check in, the essentials of Navut are together in one easy-to-access place on your phone.</p>
              <div className="guestspace-features">
                <div><Utensils /><span><strong>In-room dining</strong><small>Browse the menu and order room service</small></span></div>
                <div><Sparkles /><span><strong>Guest services</strong><small>Request housekeeping or help from our team</small></span></div>
                <div><Wifi /><span><strong>Instant Wi-Fi access</strong><small>Find the property network details with ease</small></span></div>
                <div><MapPin /><span><strong>Our local Coorg guide</strong><small>Discover places to visit in and around Coorg</small></span></div>
                <div><BedDouble /><span><strong>Your booking</strong><small>See stay dates, room details and booking information</small></span></div>
                <div><ReceiptText /><span><strong>Invoices & bills</strong><small>View your invoices and stay bill in one place</small></span></div>
              </div>
              <p className="guestspace-note"><span>FOR STAYING GUESTS</span> Your personal GuestSpace keeps the details and services for your stay close at hand.</p>
            </div>
            <div className="guestspace-visual">
              <div className="guestspace-orbit guestspace-orbit-one" />
              <div className="guestspace-orbit guestspace-orbit-two" />
              <p><span>NAVUTONE</span> GUESTSPACE</p>
              <img src={NavutOneMockup} alt="NavutOne GuestSpace showing booking details and guest services on a phone" loading="lazy" />
            </div>
          </div>
        </section>

        <section className="estate-gallery">
          <div className="gallery-heading section">
            <div className="section-label"><span>05</span> The estate in frames</div>
            <div className="gallery-title-row">
              <h2>A closer look at<br /><em>life at Navut.</em></h2>
              <p>From first light across the plantation to evenings by the fire—wander through the complete Navut story.</p>
            </div>
          </div>
          <div className="gallery-rail" aria-label="Navut Homestay property gallery">
            {propertyImages.map((image, index) => (
              <figure key={image} className={index % 3 === 1 ? 'portrait-frame' : ''}>
                <img src={image} alt={`Navut Homestay and estate – view ${index + 1}`} loading="lazy" />
                <figcaption>{String(index + 1).padStart(2, '0')} / {String(propertyImages.length).padStart(2, '0')}</figcaption>
              </figure>
            ))}
          </div>
          <p className="gallery-hint"><ArrowRight size={16} /> Scroll to explore the estate</p>
        </section>

        <section className="reviews section" id="reviews">
          <div className="section-label"><span>06</span> Guest impressions</div>
          <div className="reviews-heading">
            <div>
              <p className="eyebrow">WORDS FROM THE ROAD</p>
              <h2>Stayed. Savoured.<br /><em>Remembered.</em></h2>
            </div>
            <p>Independent guest reviews offer the clearest glimpse of life at Navut. Explore current feedback directly from Tripadvisor and Google.</p>
          </div>
          <div className="review-platforms">
            <div className="tripadvisor-widget-panel">
              <p className="review-platform-label">TRIPADVISOR</p>
              <TripadvisorWidget />
            </div>
            <a className="google-reviews-panel" href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer">
              <div className="google-reviews-brand"><img src={GoogleLogo} alt="Google" /> Google Reviews</div>
              <div>
                <div className="google-star-row" aria-label="Five stars">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} size={24} fill="currentColor" />)}
                </div>
                <h3>Read our latest<br />Google reviews.</h3>
                <p>See live guest ratings, recent comments and traveller photographs directly on Google.</p>
              </div>
              <span className="google-review-link">Open Google Reviews <ArrowRight size={17} /></span>
            </a>
          </div>
        </section>

        <section className="amenities section">
          <div className="section-label"><span>07</span> Thoughtful comforts</div>
          <div className="amenities-heading"><h2>Everything you need.<br /><em>Nothing you don’t.</em></h2><p>Simple comforts — from breakfast and Wi-Fi to the freedom of bringing your pet.</p></div>
          <div className="amenities-grid">
            {amenityGroups.map(({ icon: Icon, title, items }) => (
              <article key={title}><Icon /><h3>{title}</h3>{items.map(item => <p key={item}><Check size={14} /> {item}</p>)}</article>
            ))}
          </div>
          <div className="good-to-know">
            <div className="good-to-know-heading"><p className="eyebrow">BEFORE YOU ARRIVE</p><h2>Its always good to know.</h2></div>
            <div className="stay-details">
              <article><span>01</span><h3>Arrival</h3><p>Check-in from 1:00 PM</p><p>Check-out by 11:00 AM</p><small>Please share your expected arrival time in advance.</small></article>
              <article><span>02</span><h3>Meal times</h3><p>Breakfast · 8:00–11:00 AM</p><p>Lunch · 1:00–4:00 PM</p><p>Dinner · 8:00–10:30 PM</p><small>Breakfast is complimentary with your stay.</small></article>
              <article><span>03</span><h3>Lunch & dinner</h3><p>Semi-buffet · approx. ₹250 per guest</p><p>Full buffet · approx. ₹400 per guest</p><small>Vegetarian and non-vegetarian options are available. Final pricing depends on quantity.</small></article>
              <article><span>04</span><h3>Children</h3><p>Guests below 18 stay free</p><p>Maximum four guests per room</p><small>The existing king bed and sofa bed, which comfortably fits 2 adults, form the complete bedding arrangement.</small></article>
              <article><span>05</span><h3>Alcohol policy</h3><p>We do not sell or serve alcohol</p><p>You may bring your own</p><small>Please enjoy responsibly and be considerate of other guests.</small></article>
              <article><span>06</span><h3>Cancellations</h3><p>Contact the property directly</p><p>Refunds are handled individually</p><small>We will guide you according to your booking and applicable terms.</small></article>
              <article><span>07</span><h3>Driver stay</h3><p>Driver accommodation is available</p><p>Advance confirmation required</p><small>Please contact us before arrival as space is subject to availability.</small></article>
              <article><span>08</span><h3>Parking & access</h3><p>Free on-site parking</p><p>10 km from Virajpet</p><small>Madikeri is approximately 45–60 minutes away by road.</small></article>
            </div>
          </div>
        </section>

        <section className="booking section" id="book">
          <div className="booking-panel">
            <div className="booking-intro">
              <p className="eyebrow light">PLAN YOUR ESCAPE</p>
              <h2>Book your<br /><em>stay at Navut.</em></h2>
              <p>Rates shown by booking partners are generally for two adults per night. Additional guests are ₹999 each, up to four guests per room.</p>
              <div className="timings"><Clock3 /><span><small>CHECK-IN</small><strong>1:00 PM</strong></span><span><small>CHECK-OUT</small><strong>11:00 AM</strong></span></div>
            </div>
            <div className="partner-list">
              <button className="direct-booking-option" type="button" onClick={openDirectBooking}>
                <span className="direct-booking-icon"><Sparkles /></span>
                <span className="direct-booking-copy"><small>THE SIMPLEST WAY TO STAY</small><strong>Book directly with us.</strong><em>Live availability · clear pricing · personal confirmation</em></span>
                <span className="direct-booking-action">Start booking <ArrowRight size={17} /></span>
              </button>
              {bookingPartners.map(partner => (
                <a key={partner.name} href={partner.url} target="_blank" rel="noreferrer">
                  <img src={partner.logo} alt={partner.name} /><span>Check availability <ArrowRight size={17} /></span>
                </a>
              ))}
              <a className="direct-row" href={`https://wa.me/${PHONE.replace('+', '')}`} target="_blank" rel="noreferrer">
                <span><Phone size={18} /> Prefer to speak with us?</span><strong>Message directly <ArrowRight size={17} /></strong>
              </a>
            </div>
          </div>
        </section>

        <section className="contact section" id="contact">
          <img src={P2} alt="Forest surrounding Navut Homestay" />
          <div className="contact-card">
            <img src={Logo} alt="Navut" />
            <p className="eyebrow">CONTACT US</p>
            <h2>Let’s plan your<br /><em>Coorg escape.</em></h2>
            <p>Questions about rooms, meals, pets or getting here? Speak with us directly—we’ll be happy to help.</p>
            <div className="contact-actions">
              <a href={`tel:${PHONE}`}><Phone size={17} /><span><small>CALL US</small>+91 98452 86195</span></a>
              <a href={`https://wa.me/${PHONE.replace('+', '')}`} target="_blank" rel="noreferrer"><MessageCircle size={17} /><span><small>WHATSAPP</small>Message Navut</span></a>
              <a href="mailto:navuthotels@gmail.com"><Mail size={17} /><span><small>EMAIL</small>navuthotels@gmail.com</span></a>
              <a href="https://www.instagram.com/navuthomestay/" target="_blank" rel="noreferrer"><Instagram size={17} /><span><small>INSTAGRAM</small>@navuthomestay</span></a>
            </div>
          </div>
        </section>

        <section className="map-section" aria-labelledby="map-title">
          <div className="map-copy">
            <p className="eyebrow">LOCATION</p>
            <h2 id="map-title">Find your way<br /><em>to the quiet.</em></h2>
            <p>Navut Homestay<br />Survey No. 288/*/24, Kedamallur Village<br />Virajpet, Karnataka 571218<br /><br />10 km from Virajpet · approximately 45–60 minutes from Madikeri</p>
            <div className="map-actions">
              <a href={MAPS_URL} target="_blank" rel="noreferrer">Open Google Maps <ArrowRight size={16} /></a>
              <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer">Read Google reviews <Star size={15} /></a>
            </div>
          </div>
          <div className="map-embed">
            <iframe
              src={MAPS_EMBED_URL}
              title="Satellite map showing Navut Homestay in Kedamallur, Coorg"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </section>

        <section className="policies section" id="policies">
          <div className="section-label"><span>08</span> Policies & important information</div>
          <div className="policies-heading">
            <div>
              <p className="eyebrow">CLEAR BEFORE YOU BOOK</p>
              <h2>The finer details,<br /><em>made simple.</em></h2>
            </div>
            <p>These plain-language summaries help you plan confidently. Your confirmed rate plan and booking confirmation take precedence where specific terms differ.</p>
          </div>
          <div className="policy-list">
            <details id="cancellation-policy">
              <summary><span>01</span><strong>Booking, cancellation & refunds</strong><ChevronRight /></summary>
              <div className="policy-content">
                <p>For direct reservations, please contact Navut Homestay as soon as possible to request a date change or cancellation. Refund eligibility and any deductions depend on the terms agreed when your stay was confirmed.</p>
                <p>Reservations made through Agoda, MakeMyTrip, Goibibo, Booking.com or another travel platform are governed by the cancellation and refund conditions shown by that platform at the time of booking. Requests should normally be initiated through the same platform.</p>
                <p>Approved refunds may take additional time to appear depending on the payment provider. Changes, extensions, early departures and room-category upgrades remain subject to availability and any applicable price difference.</p>
              </div>
            </details>
            <details id="stay-terms">
              <summary><span>02</span><strong>Stay terms & house rules</strong><ChevronRight /></summary>
              <div className="policy-content policy-columns">
                <div><h3>Your confirmed stay</h3><p>The guest count, room category, rate plan and inclusions recorded in your booking confirmation form the basis of your reservation. Please contact us before arrival if any of these details change.</p></div>
                <div><h3>Property conduct</h3><p>Please respect other guests, staff, quiet hours, the surrounding estate and property facilities. Unlawful activity or behaviour that risks the safety or comfort of others is not permitted.</p></div>
                <div><h3>Damage & loss</h3><p>Guests may be responsible for reasonable costs arising from avoidable damage, missing property or exceptional cleaning attributable to their stay.</p></div>
                <div><h3>Published guest information</h3><p>The practical occupancy, allocation, dining and arrival guidance shown in the Accommodation and Good to Know sections forms part of this stay information.</p></div>
              </div>
            </details>
            <details id="privacy-policy">
              <summary><span>03</span><strong>Privacy & third-party services</strong><ChevronRight /></summary>
              <div className="policy-content">
                <p>This website does not contain a reservation form and does not directly collect card or payment details. If you call, email or message us, we use the information you voluntarily provide to answer your enquiry, help arrange a stay, provide guest services and maintain relevant booking records.</p>
                <p>Our hosting provider may process basic technical logs such as IP address, browser type, device information and request timestamps for security and site operation. We do not sell your personal information.</p>
                <p>The site includes content or links from Google Maps, Tripadvisor, WhatsApp, Instagram and online travel agencies. Those services may process device data, cookies or similar storage under their own privacy policies. Browser tracking-prevention settings may restrict some embedded features without affecting the rest of this website.</p>
                <p>To ask about personal information shared directly with Navut, contact <a href="mailto:navuthotels@gmail.com">navuthotels@gmail.com</a>.</p>
              </div>
            </details>
            <details id="website-disclaimer">
              <summary><span>04</span><strong>Website information & disclaimer</strong><ChevronRight /></summary>
              <div className="policy-content">
                <p>We aim to keep this website accurate and current. Photographs represent the property and room categories, although individual rooms, furnishings, views and seasonal surroundings can vary.</p>
                <p>Any figure described as approximate—including meal prices, travel times and attraction distances—may change with quantity, traffic, weather, route conditions or local access rules. Wildlife sightings and outdoor activities cannot be guaranteed.</p>
                <p>Live availability, final prices, taxes, offers and booking-specific conditions should be verified on your selected booking platform or directly with Navut before confirmation.</p>
              </div>
            </details>
          </div>
          <p className="policy-updated">Last updated: 24 July 2026</p>
        </section>
      </main>

      <footer>
        <div className="footer-brand"><img src={Logo} alt="" /><span><strong>NAVUT</strong><small>HOMESTAY · COORG</small></span></div>
        <div className="footer-contact">
          <a href={`tel:${PHONE}`}><Phone size={16} /> +91 98452 86195</a>
          <a href="mailto:navuthotels@gmail.com"><Mail size={16} /> navuthotels@gmail.com</a>
        </div>
        <div className="footer-social">
          <a href="https://www.instagram.com/navuthomestay/" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram /></a>
          <button onClick={share} aria-label="Share Navut Homestay"><Share2 /></button>
        </div>
        <nav className="footer-policy-links" aria-label="Policies">
          <a href="#cancellation-policy" onClick={(event) => { event.preventDefault(); openPolicy('cancellation-policy'); }}>Cancellation</a>
          <a href="#stay-terms" onClick={(event) => { event.preventDefault(); openPolicy('stay-terms'); }}>Stay terms</a>
          <a href="#privacy-policy" onClick={(event) => { event.preventDefault(); openPolicy('privacy-policy'); }}>Privacy</a>
          <a href="#website-disclaimer" onClick={(event) => { event.preventDefault(); openPolicy('website-disclaimer'); }}>Disclaimer</a>
        </nav>
        <div className="footer-legal">
          <p>Navut Homestay is owned and operated by Xyka Hotels India Private Limited.</p>
          <p className="copyright">© {new Date().getFullYear()} Xyka Hotels India Private Limited. NAVUT&trade; is a trademark of Xyka Hotels India Private Limited. All rights reserved.</p>
        </div>
      </footer>

      <button className="mobile-book" onClick={() => scrollTo('book')}>Book your stay <ArrowRight size={17} /></button>
      {bookingOpen && <BookingModal onClose={closeDirectBooking} onShare={shareDirectBooking} />}
    </div>
  );
}

export default App;
